<template>
  <div class="extract">
    <el-row class="table-header">
			<el-col style="width: 180px; margin-right: 20px;">
				<el-select
					v-model="params.is_goods"
					@change="handleIsGoodsChange"
					placeholder="全部"
				>
					<el-option :value="0" label="奖品订单"></el-option>
					<el-option :value="1" label="商品订单"></el-option>
				</el-select>
			</el-col>
      <el-col style="width: 180px; margin-right: 20px;">
        <el-select
          v-model="params.state"
          @change="handleStateChange"
					placeholder="全部"
        >
          <el-option :value="1" label="待处理"></el-option>
					<el-option :value="30" label="扎比特报价中"></el-option>
					<el-option :value="31" label="扎比特等待发货"></el-option>
					<el-option :value="32" label="扎比特等待收货"></el-option>
					<el-option :value="33" label="扎比特交易成功"></el-option>
					<el-option :value="34" label="订单取消或订单失败"></el-option>
        </el-select>
      </el-col>
      <el-col style="width: 200px; margin-right: 20px;">
        <el-input
          v-model="params.user_id"
          placeholder="用户ID"
        ></el-input>
      </el-col>
      <el-col style="width: 200px; margin-right: 20px;">
        <el-input
          v-model="params.user_name"
          placeholder="用户名称"
        ></el-input>
      </el-col>
			<el-col style="width: 200px; margin-right: 20px;">
				<el-input
					v-model="params.prize_name"
					placeholder="物品名称"
				></el-input>
			</el-col>
			<el-col style="width: 200px; margin-right: 20px;">
				<el-input
					v-model="params.user_tag"
					placeholder="用户标签"
				></el-input>
			</el-col>

      <el-col style="width: 220px; margin-right: 20px;">
        <el-date-picker
          v-model="params.start_time"
          type="datetime"
          placeholder="开始日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-col>
      <el-col style="width: 220px; margin-right: 20px;">
        <el-date-picker
          v-model="params.end_time"
          type="datetime"
          placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-col>
      <el-col style="width: 80px; margin-right: 20px;">
        <el-button
          @click="handleSearch"
          type="primary"
          icon="el-icon-search"
          >搜索</el-button
        >
      </el-col>
      <el-col style="width: 80px; margin-right: 20px;">
        <el-button @click="handleExport"
          >导出</el-button
        >
      </el-col>
			<el-col style="width: 80px; margin-right: 20px;">
        <el-button @click="handleSelectedChange"
          >修改状态</el-button
        >
      </el-col>
      <el-col style="width: 200px; margin-right: 20px;">
        <span v-if="amount">总金额：{{ amount }}</span>
      </el-col>
    </el-row>
    <el-table :data="dataList" v-loading="loading" @selection-change="handleSelectionChange">
			<el-table-column type="selection" align="center" />
       <el-table-column prop="id" label="ID" width="60px"></el-table-column>
      <el-table-column
        label="用户ID"
        width="100px"
      >
        <template slot-scope="{ row }">
          <!-- <span @click="$router.push(`/user/${row.user_id}`)">{{ row.user_id }}</span> -->
          <span @click="pathToUser(row.user_id)">{{ row.user_id }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="user_info" label="用户信息">
        <template slot-scope="{ row }">
          <!-- <div class="user-avatar" v-if="row.user" @click="$router.push(`/user/${row.user_id}`)"> -->
          <div class="user-avatar" v-if="row.user" @click="pathToUser(row.user_id)">
            <img :src="row.user.avatar || '/images/default-avatar.jpg'" alt />
            <span>{{ row.user.name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="user_type" label="用户类型">
        <template slot-scope="{ row }" v-if="row.user">
          <el-tag v-if="row.user.type === 1" type="info">普通用户</el-tag>
          <el-tag v-if="row.user.type === 2" type="success">主播</el-tag>
          <el-tag v-if="row.user.type === 7" type="success">主播（新）</el-tag>
          <el-tag v-if="row.user.type === 4" type="warning">代理</el-tag>
          <el-tag v-if="row.user.type === 6" type="warning">试用期代理</el-tag>
          <el-tag v-if="row.user.type === 3" type="primary">测试账号</el-tag>
        </template>
      </el-table-column>
			<el-table-column
				prop="user.user_tag"
				label="用户标签"
				width="60px"
			></el-table-column>
      <el-table-column prop="prize" label="物品信息" width="280px">
        <template slot-scope="{ row }">
          <div class="prize-info" v-if="row.prize">
            <img :src="row.prize.image" alt />
            <div class="prize-text">
              <p>{{ row.prize.name }}</p>
              <p :style="`color: ${getRankColor(row.prize.rank)}`">
                {{ row.prize.second_name }}
              </p>
              <p class="price">$ {{ row.prize.price }}</p>
            </div>
          </div>
        </template>
      </el-table-column>
			<el-table-column prop="zbt" label="ZBT购买价格（T币）">
				<template slot-scope="{ row }">
					<section v-if="row.zbt !== null">
						{{row.zbt.buyPrice}}&nbsp;&nbsp;T
					</section>
				</template>
			</el-table-column>
      <el-table-column
        prop="number"
        label="数量"
        width="60px"
      ></el-table-column>
      <el-table-column
        prop="created_at"
        label="操作时间"
        width="180px"
      ></el-table-column>
      <el-table-column prop="state" label="订单状态" width="100px">
        <template slot-scope="{ row }">
          <el-tag v-if="row.state === 1">待处理</el-tag>
          <el-tag v-if="row.state === 2" type="success">处理通过</el-tag>
          <el-tag v-if="row.state === 3" type="danger">处理未通过</el-tag>
          <el-tag v-if="row.state === 4" type="warning">机器人报价中</el-tag>
          <el-tag v-if="row.state === 5" type="success">报价成功</el-tag>
          <el-tag v-if="row.state === 6" type="danger">报价失败</el-tag>
          <el-tag v-if="row.state === 7" type="success">处理通过</el-tag>
          <el-tag v-if="row.state === 9" type="success">处理通过</el-tag>
					<el-tag v-if="row.state === 100" type="success">处理通过</el-tag>
          <el-tag v-if="row.state === 30" type="success">扎比特报价中</el-tag>
          <el-tag v-if="row.state === 31" type="success">扎比特等待发货</el-tag>
          <el-tag v-if="row.state === 32" type="success">扎比特等待收货</el-tag>
          <el-tag v-if="row.state === 33" type="success">扎比特交易成功</el-tag>
          <el-tag v-if="row.state === 34" type="success">订单取消或订单失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="order_no" label="订单号"></el-table-column>
			<el-table-column prop="zbt.buyPrice" label="ZBT价格"></el-table-column>
      <el-table-column prop="remark" label="备注信息"></el-table-column>
      <el-table-column prop="action" label="操作" width="130px">
        <template slot-scope="{ row }">
          <el-button type="primary" @click="handleChange(row)"
            >修改订单</el-button
          >
					<el-button type="success" @click="zbtSearch(row)" v-if="row.type === 1 && (row.delivery_type === 3||row.delivery_type === 4) && row.state === 1"
					>扎比特</el-button
					>
        </template>
      </el-table-column>
			<el-table-column  prop="action" label="同步状态" width="130px">
        <template slot-scope="{ row }">
          <el-button type="primary" v-if="row.state !== 1" @click="syncZbtOrder(row)">同步状态</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="dataMeta ? dataMeta.total : 0"
      :current-page="dataMeta ? dataMeta.current_page : 1"
      :page-size="dataMeta ? dataMeta.per_page : 15"
      @current-change="handlePageChange"
    ></el-pagination>
    <el-dialog
      :visible.sync="visibleEdit"
      title="修改订单状态"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-row class="form-item">
        <el-col :span="8">
          <span>订单状态：</span>
        </el-col>
        <el-col :span="16">
          <el-select v-model="state">
            <el-option :value="1" label="待处理"></el-option>
            <el-option :value="2" label="处理通过"></el-option>
            <el-option :value="3" label="处理未通过"></el-option>

					</el-select>
        </el-col>
      </el-row>
      <el-row class="form-item" v-if="params.type === 1">
        <el-col :span="8">
          <span>用户交易URL：</span>
        </el-col>
        <el-col :span="16">
          <span>{{ editInfo && editInfo.user.transaction_url }}</span>
          <i
            class="el-icon-s-order"
            v-if="editInfo"
            v-clipboard:copy="editInfo.user.transaction_url"
            v-clipboard:success="onCopy"
            style="font-size: 24px; cursor: pointer;"
            title="复制到粘贴板"
          ></i>
        </el-col>
      </el-row>
      <el-row class="form-item" v-if="params.type === 1">
        <el-col :span="8">
          <span>用户QQ：</span>
        </el-col>
        <el-col :span="16">
					<span>{{ editInfo && editInfo.user.qq_id }}</span>
					<i
						class="el-icon-s-order"
						v-if="editInfo"
						v-clipboard:copy="editInfo.user.qq_id"
						v-clipboard:success="onCopy"
						style="font-size: 24px; cursor: pointer;"
						title="复制到粘贴板"
					></i>
        </el-col>
      </el-row>
      <el-row class="form-item">
        <el-col :span="8">
          <span>备注：</span>
        </el-col>
        <el-col :span="16">
          <el-input v-model="remark"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleEdit = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submit"
          :loading="buttonLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
		<el-dialog
			:visible.sync="visibleSelectEdit"
			title="修改选中订单状态"
			width="400px"
			:close-on-click-modal="false"
		>
			<el-row class="form-item">
				<el-col :span="8">
					<span>订单状态：</span>
				</el-col>
				<el-col :span="16">
					<el-select v-model="state">
						<el-option :value="1" label="待处理"></el-option>
						<el-option :value="2" label="处理通过"></el-option>
						<el-option :value="3" label="处理未通过"></el-option>
					</el-select>
				</el-col>
			</el-row>
			<span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleSelectEdit = false">取 消</el-button>
        <el-button
					size="small"
					type="primary"
					@click="submitSelectEdit"
					:loading="buttonLoading"
				>确 定</el-button
				>
      </span>
		</el-dialog>
		<!--		扎比特饰品列表-->
		<el-dialog
			:visible.sync="visibleZbtSearch"
			title="扎比特饰品列表"
			:close-on-click-modal="false"
			width="930px"
      @close="closeZbtSearch"
		>
			<el-row style="margin-bottom: 20px;">
        <el-select
            style="width: 150px;margin-right: 20px;"
            v-model="prizeType"
            placeholder="请选择奖品分类"
          >
            <el-option :value="1" label="csgo"></el-option>
            <el-option :value="5" label="dota"></el-option>
          </el-select>
				<el-input style="width: 200px; margin-right: 20px;" placeholder="商品名称搜索" v-model="prizeName"></el-input>
				<el-button type="primary" @click="getZbtSearch">搜索</el-button>
				<span class="pull-right">扎比特余额: {{ zbtBalance }}</span>
			</el-row>
			<div class="prize-list-wrap" v-loading="loadingZbtPrize">
				<ul class="prize-list">
					<li class="prize-item" v-for="item in zbtPrizeList" :key="item.itemId">
						<i
							class="el-icon-view"
							title="查看在售列表"
							@click="showzbtSell(item)"
						></i>
						<img :src="item.imageUrl" alt />
						<p>
							<span>{{ item.itemName }}</span>
						</p>
						<p>
							<span>{{ item.marketHashName }}</span>
						</p>
						<p>
              <span :style="`color: ${item.rarityColor};`">{{item.qualityName}}</span>

							<span class="price">{{ item.priceInfo.price }} T币</span>
						</p>
						<p style="text-align: center;">
							数量：{{ item.priceInfo.quantity}}
						</p>
					</li>
				</ul>
			</div>
      <el-pagination
				background
				:page-size="zbtPrizeMeta.limit || 15"
				:total="zbtPrizeMeta.total || 0"
				:current-page="zbtPrizeMeta.page || 1"
				@current-change="handlePrizePageChange"
				v-if="zbtPrizeMeta && zbtPrizeMeta.total > zbtPrizeMeta.limit"
			></el-pagination>
		</el-dialog>
		<!--		扎比特商品在售列表-->
		<el-dialog
			:visible.sync="visibleZbtSellProduct"
			title="扎比特商品在售列表"
			:close-on-click-modal="false"
			width="1000px"
      @close="closeZbtSell"
		>
			<div class="prize-list-wrap" v-loading="loadingZbtSellProduct">
				<ul class="prize-list">
					<li class="prize-item" v-for="sellerInfo in zbtSellProductList" :key="sellerInfo.id">
						<i
							class="el-icon-wallet"
							title="查看在售列表"
							@click="zbtDeliver(sellerInfo)"
						></i>
						<img :src="sellerInfo.imageUrl" alt />
						<p>
							<span>{{ sellerInfo.itemName }}</span>
						</p>
						<p>
							<span>发货类型:{{ sellerInfo.delivery === 1?'手动发货': '自动发货'}}</span>
						</p>
						<p>
              <span >{{sellerInfo.cnyPriceTrue}}元</span>
							<span class="price">{{ sellerInfo.price }} T币</span>
						</p>
					</li>
				</ul>
			</div>
      <el-pagination
				background
				:page-size="zbtSellProductMeta.limit || 10"
				:total="zbtSellProductMeta.total || 0"
				:current-page="zbtSellProductMeta.page || 1"
				@current-change="handleSellPageChange"
				v-if="zbtSellProductMeta && zbtSellProductMeta.total > zbtSellProductMeta.limit"
			></el-pagination>
		</el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ranks from '../../utils/ranks'
import http, { patchData, getData, server, postApiData, getApiData } from '../../http'
import saveFile from '../../utils/saveFile'
export default {
  data() {
    return {
      loading: false,
      params: {
        page: 1,
        type: 1,
				delivery_type: 3,
				is_goods: undefined,
        state: 1,
        user_id: '',
        user_name: '',
        prize_name: '',
        start_time: '',
        end_time: '',
				user_tag: ''
      },
      visibleEdit: false,
			visibleSelectEdit: false,
      editInfo: undefined,
      state: undefined,
      remark: '',
      buttonLoading: false,
      url: '',
			multipleSelection: [],
			// 扎比特
			zbtBalance: '',
      prizeType:'',//zbt奖品类别 1是csgo 5是dota
			prizeName: '',
			itemId: '',
			extractId: '',
			loadingZbtPrize: false,
			loadingZbtSellProduct: false,
      buyLock:false,//购买锁，防重复点击
			visibleZbtSearch: false,
			visibleZbtSellProduct: false,
			zbtPrizeList: [],
      zbtSellProductList: [],
      zbtPrizeMeta: {},
      zbtSellProductMeta: {},
      sellPage: 1, // 扎比特商品-在售列表分页
      page: 1 // 扎比特饰品-列表分页
    }
  },
  computed: {
    ...mapState({
      dataList: state => state.data.extractOrderList.data,
      amount: state => state.data.extractOrderList.amount,
      dataMeta: state => state.data.extractOrderList.meta
    })
  },
  methods: {
    ...mapActions(['getExtractOrderList']),
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		handleSelectedChange() {
			if (this.multipleSelection.length > 1) {
				this.visibleSelectEdit = true
			}
		},
		submitSelectEdit() {
			this.buttonLoading = true
			const ids = this.multipleSelection.map((item) => {
				return item.id
			})
			patchData(`extract/update_multiple`, {
				ids: ids,
				state: this.state,
				remark: this.remark
			})
				.then(res => {
					this.$message.success('修改成功')
					this.visibleSelectEdit = false
					this.getData()
				})
				.finally(() => {
					this.buttonLoading = false
				})
		},
    getRankColor(rank) {
      for (let item of ranks) {
        if (item.level === rank) {
          return item.color
        }
      }
    },
    getData() {
      this.loading = true
      this.getExtractOrderList(this.params).finally(() => {
        this.loading = false
      })
    },
    handlePageChange(page) {
      this.params.page = page
      this.getData()
    },
    handleChange(row) {
      this.editInfo = row
      this.state = row.state
      this.remark = row.remark
      this.visibleEdit = true
    },
    submit() {
      this.buttonLoading = true
      patchData(`extract/${this.editInfo.id}`, {
        state: this.state,
        remark: this.remark
      })
        .then(res => {
          this.$message.success('修改成功')
          this.visibleEdit = false
          this.getData()
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    handleTypeChange(type) {
      this.params.page = 1
      if (type === 2) {
        this.params.state = 2
      } else {
        this.params.state = 1
      }
      this.getData()
    },
		handleIsGoodsChange(is_goods) {
      this.params.page = 1
			this.params.is_goods = is_goods
      this.getData()
    },
    handleStateChange() {
      this.params.page = 1
      this.getData()
    },
    handleSearch() {
      this.params.page = 1
      this.getData()
    },
    onCopy() {
      this.$message.success('已成功复制到粘贴板')
    },
    handleExport() {
      http
        .post(
          server + 'extract_export',
          { ...this.params, page: undefined },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '提取订单记录.xlsx'
          })
        })
    },
		getZbtBalance(row) {
			getData(`zbt/balance`)
				.then(res => {
					this.zbtBalance = res.data.data
				})
		},
		zbtSearch(row) {
			this.visibleZbtSearch = true
      this.prizeType = row.prize.category_id
			this.prizeName = row.prize.name
			this.extractId = row.id
		},
		getZbtSearch(row) {
			this.loadingZbtPrize = true

      let appId=undefined
      if(this.prizeType===1){
        appId=730
      }else if(this.prizeType===5){
        appId=570
      }

			getApiData(`zbt/search`, {  app_id:this.prizeType,keyword: this.prizeName, page: this.page, limit: 15 })
				.then(res => {
					this.zbtPrizeList = res.list
					this.zbtPrizeMeta = res
				})
				.finally(() => {
					this.loadingZbtPrize = false
				})
    },
    showzbtSell (row) {
			this.visibleZbtSellProduct = true
      this.itemId = row.itemId
      this.getZbtSellProduct()
    },
		getZbtSellProduct (row) {
			this.loadingZbtSellProduct = true
			getApiData(`zbt/sell_product`, { itemId: this.itemId, page: this.sellPage })
				.then(res => {
					this.zbtSellProductList = res.list
					this.zbtSellProductMeta = res
				})
				.finally(() => {
					this.loadingZbtSellProduct = false
				})
		},
		zbtDeliver(row) {
      if(this.buyLock){
        //防止重复点击
        this.$message.error("请勿重复点击！")
        return
      }
      this.buyLock=true
			postApiData(`zbt/buy/` + this.extractId, { productId: row.id, buyPrice: row.price, delivery: row.delivery })
				.then(res => {
					this.$message.success('购买成功')
					this.visibleZbtSellProduct = false
					this.visibleZbtSearch = false
					this.getData()
          //解锁
          this.buyLock=false
				}).catch(error=>{
          //解锁
          this.buyLock=false
        })
		},
		syncZbtOrder(row) {
      if (!row.order_no) {
        return false
      }
			getApiData(`zbt/buy_detail/` + row.order_no)
				.then(res => {
					this.getData()
				})
    },
    handlePrizePageChange (page) {
      this.page = page
      this.getZbtSearch()
    },
    handleSellPageChange (page) {
      this.sellPage = page
      this.getZbtSellProduct()
    },
    closeZbtSearch () {
      this.page = 1
      this.zbtPrizeMeta = {}
      this.zbtPrizeList = []
    },
    closeZbtSell () {
      this.sellPage = 1
      this.zbtSellProductMeta = {}
      this.zbtSellProductList = []
    },
    pathToUser (id) {
      let routeData = this.$router.resolve({ path: `/user/${id}` })
      window.open(routeData.href, '_blank')
    }
  },
  created() {
    this.getData()
    this.getZbtBalance()
  }
}
</script>

<style>
	.prize-list .el-icon-view ,.prize-list .el-icon-wallet{
		position: absolute;
		right: 5px;
		top: 5px;
		font-size: 16px;
		width: 24px;
		height: 24px;
		border-radius: 12px;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		color: #fff;
		background-color: #409eff;
		cursor: pointer;
		-webkit-transition: all 0.3s;
		transition: all 0.3s;
	}
</style>
